import { RouteLocationNormalized } from 'vue-router'
import { Person } from '@/api/entities/people/types'
import { EntityRole } from '@/legacy/types/entities/entities'
import {
  LlmFeature,
  LlmDatadogLoggingDetails,
  GenericLlmResponse,
} from '@/libs/features/llm/types'
import { DevToolOptions } from '@/tokens/llm/LlmDevTools/types'

/**
 *
 * @param opts
 * @param opts.response
 * @param opts.route
 * @param opts.feature
 * @param opts.query
 * @param opts.devToolOptions
 * @param opts.person
 * @param opts.roles
 */
export function buildLlmDatadogLoggingDetails(opts: {
  response: GenericLlmResponse
  route: RouteLocationNormalized
  feature: LlmFeature
  query?: string
  devToolOptions?: DevToolOptions
  person?: Person
  roles: EntityRole[]
}): LlmDatadogLoggingDetails {
  return {
    rawLogId: opts.response?.rawLogId,
    route: opts.route,
    feature: opts.feature,
    query: opts.query,
    model: opts.devToolOptions?.model,
    temperature: opts.devToolOptions?.temperature,
    maxResponseTokens: opts.devToolOptions?.maxResponseTokens,
    person: opts.person,
    roles: opts.roles,
  }
}
